import React, { Component } from "react";

import "./header.css";

class Header extends Component {
  render() {
    return (
      <div className="header">
        <p className="header-description">
          This is folkhack's version of the rebane mapart tool — with transparency support, and modern block pallets.
        </p>
      </div>
    );
  }
}

export default Header;
